import { LocalService } from './../../../../services/storage/localService';
import { Component, OnInit, EventEmitter, Output, Input, OnDestroy} from '@angular/core';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { DatePipe, DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { SimuladoresDetalle } from '../../../../models/SimuladoresDetalle';
import { InversionistaDetalle } from '../../../../models/InversionistaDetalle'; 
import * as moment from 'moment';
import { MessagesGeneral, MessagesDates, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../../models/messages';
import { ErrorModel } from '../../../../models/ErrorModel';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material';

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-insertar-inversionista',
  templateUrl: './insertar-inversionista.component.html',
  styleUrls: ['./insertar-inversionista.component.scss'],
  providers: [
    DatePipe,
    DecimalPipe,MessagesTitles,MessagesGeneral,MessagesDates,MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class InsertarInversionistaComponent implements OnInit {

  @Output() cerrarsimuladorDetalle: EventEmitter<boolean>;
  @Output() itemSimuladorDetalle = new EventEmitter();
  @Output() itemInversionistaDetalle = new EventEmitter();
  @Input() fechaDesembolso :any;
  @Input() listaFondos: any;
  @Input() SimuladorTotales: any;
  @Input() tipo: any;
   
  InversionistaDetalle: InversionistaDetalle ;
  IGV = true;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  errorFecha = new ErrorModel() ;
  errorVNPP= new ErrorModel() ;
  retencionBaseElement : any;
  fondoGarantiaBaseElement : any;
  plazo : any;

  readonly varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
  readonly varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
 
  fondoCtrl: FormControl = new FormControl();
  fondoFilterCtrl: FormControl = new FormControl();
  filteredFondos: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  protected onDestroy$ = new Subject<void>();

  constructor(  private decimalPipe: DecimalPipe,
    private msgAgregarSimulador : MessagesSimuladorAgregarDetalle,
    private localService : LocalService) {

    this.cerrarsimuladorDetalle = new EventEmitter(); 
    this.InversionistaDetalle = new InversionistaDetalle();
    console.log(this.tipo);
      if (this.tipo == 'edit'){
        console.log('sim-->',this.SimuladorTotales);
        
      }else{
        console.log("no entro primer if");
      }

   }

  ngOnInit() { 
    this.InversionistaDetalle.IGV_Factura_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');  
    this.calcularDiferenciaDias();
    
    this.filteredFondos.next(this.listaFondos.slice());

    this.fondoFilterCtrl.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.filtrarFondos();
      });

  }
    

  calcularDiferenciaDias(){    
   // this.SimuladorDetalle.Plazo = this.diferenciaEntreDiasEnDias(this.SimuladorDetalle.Fecha_de_Pago['_d'],this.fechaDesembolso['_d']);
  }

  MetcerrarSimuladorDetalle(){

    this.cerrarsimuladorDetalle.emit();
  }

  EnviarItemSimuladorDetalle(){    
    this.calcularInversion();
    this.itemInversionistaDetalle.emit(this.InversionistaDetalle);
  }

  calcularInversion(){
    this.errorFecha = new ErrorModel() ;
    this.errorVNPP= new ErrorModel() ;
 
    if(this.tipo == 'edit'){
      
      console.log("entro z",this.SimuladorTotales);
      let contdays = this.diferenciaEntreDiasEnDias(this.InversionistaDetalle.fecha_inversion['_d'],new Date(this.SimuladorTotales.fecha_desembolso));
      
      let contdaysOriginal = this.diferenciaEntreDiasEnDias(new Date(this.SimuladorTotales.fecha_vencimiento),new Date(this.SimuladorTotales.fecha_desembolso));
       
      this.InversionistaDetalle.Plazo = contdaysOriginal - contdays;
      console.log("entro editt 1", this.InversionistaDetalle);
      console.log("day 1", contdays);
      console.log("day origin", contdaysOriginal);
    }else{
      this.InversionistaDetalle.Plazo = this.SimuladorTotales.Plazo;
    }
    
    this.InversionistaDetalle.Detraccion_Porcentaje = this.InversionistaDetalle.Detraccion_Porcentaje/100;
    this.InversionistaDetalle.Fondo_Garantia_Porcentaje = this.InversionistaDetalle.Fondo_Garantia_Porcentaje/100;
    this.InversionistaDetalle.Retencion_Porcentaje = this.InversionistaDetalle.Retencion_Porcentaje/100;
    this.InversionistaDetalle.VNPP = this.cortarComa(this.InversionistaDetalle.VNPP);
    this.InversionistaDetalle.IGV_Factura_Importe = this.cortarComa(this.InversionistaDetalle.IGV_Factura_Importe);
    this.InversionistaDetalle.Precio_Venta = this.cortarComa(this.InversionistaDetalle.Precio_Venta);
    this.InversionistaDetalle.Valor_Venta = this.cortarComa(this.InversionistaDetalle.Valor_Venta);

    this.InversionistaDetalle.porcentaje_retroventa =    Number(this.InversionistaDetalle.Valor_Inversion)/Number(this.SimuladorTotales.Valor_Venta_Retroventa);   
    
      this.InversionistaDetalle.Otros_Descuentos = this.SimuladorTotales.Otros_Descuentos*this.InversionistaDetalle.porcentaje_retroventa;
     
    this.InversionistaDetalle.Valor_Inversion = Number(this.InversionistaDetalle.Valor_Inversion);
    this.InversionistaDetalle.Proporcion_Retroventa = this.SimuladorTotales.Adelanto*this.InversionistaDetalle.porcentaje_retroventa;
     
    this.InversionistaDetalle.porcentaje_rendimiento = this.InversionistaDetalle.porcentaje_rendimiento_show/100;
    
    
    let tasaDiaria = Math.pow(1+this.InversionistaDetalle.porcentaje_rendimiento,1/365)-1;
    let interes = (1-(1/Math.pow(1+tasaDiaria,this.InversionistaDetalle.Plazo)))*this.InversionistaDetalle.Valor_Inversion;

    this.InversionistaDetalle.rendimiento = Math.round(interes*100)/100;
    this.InversionistaDetalle.valor_vencimiento = this.InversionistaDetalle.rendimiento+this.InversionistaDetalle.Valor_Inversion;
    if(this.tipo == 'edit'){
      this.InversionistaDetalle.costo_asesoria = this.InversionistaDetalle.costo_asesoria*1;
      //this.InversionistaDetalle.Otros_Descuentos = this.InversionistaDetalle.Otros_Descuentos+(this.InversionistaDetalle.costo_asesoria*1)
      
    }else{
      this.InversionistaDetalle.costo_asesoria = 0;
    }   

    if(this.InversionistaDetalle.Tipo == 'G'){
      this.InversionistaDetalle.iva_asesoria = this.InversionistaDetalle.costo_asesoria*0.15;
      this.InversionistaDetalle.retencion_fuente = this.InversionistaDetalle.costo_asesoria*this.InversionistaDetalle.retencionFuentePorcentaje;
      this.InversionistaDetalle.retencion_iva = this.InversionistaDetalle.iva_asesoria*this.InversionistaDetalle.retencionIVAPorcentaje; 
        
      if(this.tipo == 'edit'){
        //this.InversionistaDetalle.valor_recibir = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.iva_asesoria-this.InversionistaDetalle.Otros_Descuentos+this.InversionistaDetalle.retencion_fuente+this.InversionistaDetalle.retencion_iva-this.InversionistaDetalle.costo_asesoria;
        //this.InversionistaDetalle.valor_neto = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.Otros_Descuentos-this.InversionistaDetalle.costo_asesoria;
        //this.InversionistaDetalle.rendimiento_neto =  this.InversionistaDetalle.valor_neto-this.InversionistaDetalle.Valor_Inversion;
        
        this.InversionistaDetalle.valor_recibir = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.iva_asesoria-this.InversionistaDetalle.Otros_Descuentos+this.InversionistaDetalle.retencion_fuente+this.InversionistaDetalle.retencion_iva;    
        this.InversionistaDetalle.valor_neto = this.InversionistaDetalle.valor_vencimiento;
        this.InversionistaDetalle.rendimiento_neto = this.InversionistaDetalle.rendimiento;
        this.InversionistaDetalle.porcentaje_rendimiento_neto = this.InversionistaDetalle.porcentaje_rendimiento;
        
      }else{    
        this.InversionistaDetalle.valor_recibir = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.iva_asesoria-this.InversionistaDetalle.Otros_Descuentos+this.InversionistaDetalle.retencion_fuente+this.InversionistaDetalle.retencion_iva;    
        this.InversionistaDetalle.valor_neto = this.InversionistaDetalle.valor_vencimiento;
        this.InversionistaDetalle.rendimiento_neto = this.InversionistaDetalle.rendimiento;
        this.InversionistaDetalle.porcentaje_rendimiento_neto = this.InversionistaDetalle.porcentaje_rendimiento;
      
      }
    }else{
      this.InversionistaDetalle.iva_asesoria = this.InversionistaDetalle.costo_asesoria*0.15;
      if(this.tipo == 'edit'){
        this.InversionistaDetalle.valor_recibir = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.iva_asesoria-this.InversionistaDetalle.Otros_Descuentos-this.InversionistaDetalle.costo_asesoria;
        this.InversionistaDetalle.valor_neto = this.InversionistaDetalle.valor_recibir;  
        
      }else{
        this.InversionistaDetalle.valor_recibir = this.InversionistaDetalle.valor_vencimiento-this.InversionistaDetalle.iva_asesoria-this.InversionistaDetalle.Otros_Descuentos;
        this.InversionistaDetalle.valor_neto = this.InversionistaDetalle.valor_recibir+this.InversionistaDetalle.Otros_Descuentos;  
      
      }
      

      this.InversionistaDetalle.rendimiento_neto =  this.InversionistaDetalle.valor_neto-this.InversionistaDetalle.Valor_Inversion;
      this.InversionistaDetalle.porcentaje_rendimiento_neto = this.InversionistaDetalle.porcentaje_rendimiento;
    }
    
  }
  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }
 

  calcularVNPP(){

    let otrosDescuentos = Number(this.InversionistaDetalle.Valor_Inversion);
    let VNPP;
    VNPP = Number(this.SimuladorTotales.Valor_Venta_Retroventa_Saldo) - otrosDescuentos;
    this.InversionistaDetalle.VNPP = VNPP.toFixed(2);
  }
 

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
      valor =  this.decimalPipe.transform(this.cortarComa(this.InversionistaDetalle[`${control}`]), `1.2-2` );
      this.InversionistaDetalle[`${control}`] = valor;   
  }

  cortarComa(numero: any): any {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }

  filtrarFondos(): void {
    if (!this.listaFondos) {
      return;
    }

    let search = this.fondoFilterCtrl.value;

    if (!search) {
      this.filteredFondos.next(this.listaFondos.slice());
      return;
    }

    search = search.toLowerCase();

    this.filteredFondos.next(
      this.listaFondos.filter(item => {
        const razonSocial = item.Razon_Social ? item.Razon_Social.toLowerCase() : '';
        const nombreFondo = item.Nombre_Fondo ? item.Nombre_Fondo.toLowerCase() : '';

        return razonSocial.indexOf(search) > -1 || nombreFondo.indexOf(search) > -1;
      })
    );
  }

  onFondoSelectionChange(event: MatOptionSelectionChange, item: any): void {
    if (event.isUserInput) {
      this.selectFondo(item);
    }
  }

  selectFondo(fondo: any): void { 
    this.InversionistaDetalle.Monto_Disponible = this.decimalPipe.transform(this.cortarComa(fondo.Monto_Fondo_Disponible), `1.2-2` );
    this.InversionistaDetalle.Saldo_Actual = this.decimalPipe.transform(this.cortarComa(fondo.Monto_Fondo), `1.2-2` );
    this.InversionistaDetalle.Inversionista = fondo.Razon_Social;
    this.InversionistaDetalle.InversionistaFondo = fondo.Nombre_Fondo;
    this.InversionistaDetalle.idFondo = fondo.idFondo;
    this.InversionistaDetalle.Tipo = fondo.Tipo;
    this.InversionistaDetalle.retencionFuentePorcentaje = (fondo.IGV_Exonerado=='674')?0:0.05;
    this.InversionistaDetalle.retencionIVAPorcentaje = (fondo.IGV_Exonerado=='674')?0:fondo.PorcentajeIVA;
  }

  cargarFondos(data: any[]): void {
    this.listaFondos = data || [];
    this.filteredFondos.next(this.listaFondos.slice());
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }


}
